import React from 'react';
import { IOldIconProps } from './type';

const SocialLinkedin: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 20.852h-4.444v-7.5c0-1.177-1.32-2.16-2.497-2.16-1.176 0-1.948.983-1.948 2.16v7.5H6.667V7.518h4.444V9.74c.736-1.19 2.618-1.958 3.917-1.958 2.746 0 4.972 2.268 4.972 5.014v8.056zm-15.556 0H0V7.518h4.444v13.334zm-2.222-20a2.222 2.222 0 110 4.444 2.222 2.222 0 010-4.444z"
        fill={color}
      />
    </svg>
  );
};

export default SocialLinkedin;
